export function getVideoThumbnailUrl(media) {
  const { model, imageNameThumb, imageThumb, image } = media
  const { imageName: modelImageName } = model ?? {}
  const { thumb } = modelImageName ?? {}
  const { url: thumbnailUrl } = thumb ?? {}

  return thumbnailUrl || imageThumb || imageNameThumb ||image
}
